import { ModelBase } from "@shoothill/core";
import { action, observable } from "mobx";

export class DelegateUserModel extends ModelBase<DelegateUserModel, DelegateUserDTO> {
    // #region Constructors and Disposers
    // #endregion Constructors and Disposers

    // #region Defaults and Constants

    public static readonly DEFAULT_ID = "";
    public static readonly DEFAULT_DISPLAYNAME = "";

    // #endregion Defaults and Constants

    // #region Observables

    @observable
    public id: string = DelegateUserModel.DEFAULT_ID;

    @observable
    public displayName: string = DelegateUserModel.DEFAULT_DISPLAYNAME;

    // #endregion Observables

    // #region Actions

    @action
    public reset(): void {
        this.id = DelegateUserModel.DEFAULT_ID;
        this.displayName = DelegateUserModel.DEFAULT_DISPLAYNAME;
    }

    @action
    public fromDto(dto: DelegateUserDTO): void {
        this.id = dto.id;
        this.displayName = dto.displayName;
    }

    public toDto() {
        throw new Error("Method not implemented.");
    }

    // #endregion Actions

    // #region Helpers

    public static fromDtos(dtos: DelegateUserDTO[]): DelegateUserModel[] {
        const types: DelegateUserModel[] = [];

        for (const dto of dtos) {
            const model = new DelegateUserModel();

            model.fromDto(dto);
            types.push(model);
        }

        return types;
    }

    // #endregion Helpers
}

export interface DelegateUserDTO {
    id: string;
    displayName: string;
}
